import React from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { toggleAlertAction } from '../redux/actions/userAction'

const Toast = ({ alertState, toggleAlertAction }) => {
    if (alertState.toggleAlertStatus) {
        setTimeout(() => {
            toggleAlertAction(false, undefined)
        }, alertState.duration)
    }
    return <div>
        {alertState.toggleAlertStatus && 
        <div key="alert" className={`flex fixed bottom-0 left-0 right-0 h3 z-9999 justify-center items-center relative ${alertState.color}`}>
        <p className="pl3 pr4 white f6 fw5 text-medium">{alertState.errMsg}</p>
        <span onClick={() => toggleAlertAction(false, undefined)} className="h-100 white f4 fw1 flex absolute justify-center items-center ph3 pointer dim right-0 pb1">&times;</span>
      </div>}
    </div> 
}


Toast.propTypes = {
    alertState: PropTypes.object.isRequired,
    toggleAlertAction: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    alertState: state.userState
});

export default connect(
    mapStateToProps,
    { toggleAlertAction }
)(Toast);
